module.exports = __webpack_public_path__ + "static/media/pencil_devils_rejects.194b386a.jpg";